import { render, staticRenderFns } from "./favorite.vue?vue&type=template&id=2c081634&"
import script from "./favorite.vue?vue&type=script&lang=ts&"
export * from "./favorite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports